
import React from 'react'
import { Navigate } from 'react-router-dom';

export type RouteWrapperProps = {
  guard?: () => boolean;
  redirectPath?: string;
  element: JSX.Element;
};

export default function RouteWrapper({ guard, redirectPath, element }: RouteWrapperProps) {
  if (!guard) return <>{element}</>;
  if (guard()) return <>{element}</>;
  return <Navigate to={redirectPath || '/auth'} replace />;
}

